'use client';

import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

const ShinyBeams = ({ className }: { className?: string }) => {
    const [beams, setBeams] = useState<{ left: number; delay: number; duration: number }[]>([]);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(window.innerWidth < 768);
        // Generate random beams
        const count = 6; // Number of beams
        const newBeams = Array.from({ length: count }).map(() => ({
            left: Math.random() * 100, // Random horizontal position %
            delay: Math.random() * 5, // Random delay
            duration: 5 + Math.random() * 5, // Random duration between 5-10s
        }));
        setBeams(newBeams);
    }, []);

    if (isMobile) return null;

    return (
        <div className={cn("fixed inset-0 z-50 overflow-hidden pointer-events-none", className)}>
            {beams.map((beam, index) => (
                <motion.div
                    key={index}
                    initial={{ y: '-100%', opacity: 0 }}
                    animate={{ y: '100vh', opacity: [0, 0.5, 0] }}
                    transition={{
                        duration: beam.duration,
                        repeat: Infinity,
                        delay: beam.delay,
                        ease: "linear",
                    }}
                    className="absolute top-0 w-[1px] h-[50vh] bg-gradient-to-b from-transparent via-primary/40 to-transparent"
                    style={{ left: `${beam.left}%` }}
                />
            ))}

            {/* Optional: Add a very subtle ambient glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-primary/5 blur-[100px] rounded-full pointer-events-none" />
        </div>
    );
};

export default ShinyBeams;
